/* eslint-disable camelcase */
// the unused vars need to be there otherwise the component doesn't rerender on those property change
/* eslint-disable no-unused-vars */
import React from 'react';
import { observer } from 'mobx-react';
import { Card, Text, ContentSnippet, Button, LoadingOverlay } from '@mqd/volt-base';
import { EditRiskRatingModal } from '../shared-components';
import { ParentDetailCard } from '@mq/voltron-parent';
import s from './CardholderInfoTab.module.css';

class CardholderRiskRatingCard extends ParentDetailCard {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      editActive: false,
      showEditRiskRatingModal: false,
    };
  }

  get cardholderStore() {
    const { cardholderStore = {} } = this.props;
    return cardholderStore;
  }

  renderEditRiskRatingModal() {
    const { showEditRiskRatingModal } = this.state;
    const { updateRiskRating } = this.cardholderStore;
    if (!showEditRiskRatingModal) return null;
    return (
      <EditRiskRatingModal
        options={['Low', 'Medium', 'High']}
        handleSave={async ({ value }) => {
          this.setState({ loading: true, showEditRiskRatingModal: false });
          updateRiskRating && (await updateRiskRating({ value }));
          this.setState({ loading: false });
        }}
        hideModal={() => {
          this.setState({ showEditRiskRatingModal: false });
        }}
      />
    );
  }

  renderInfo() {
    const { risk_rating, canEditRiskRating } = this.cardholderStore;
    const { editable } = this.props;

    return (
      <Card title="Risk Rating" testId="risk-rating-card">
        <div data-testid="risk-rating">
          <ContentSnippet title={'Risk rating level'} key={'risk_rating'} horizontalLayout>
            <div className={`${s.flexDiv} ${s.spaceBetween}`}>
              <Text>
                {/* Capitalizing the first letter of risk_rating if it's a string */}
                {risk_rating && typeof risk_rating === 'string'
                  ? risk_rating.replace(/^./, (char) => char.toUpperCase())
                  : risk_rating}
              </Text>
              {editable && canEditRiskRating && (
                <Button
                  size="xs"
                  type="outline"
                  onClick={() => this.setState({ showEditRiskRatingModal: true })}
                  testId={`risk_rating_edit_button`}
                >
                  Edit
                </Button>
              )}
            </div>
          </ContentSnippet>
        </div>
      </Card>
    );
  }

  render() {
    const { loading } = this.state;
    const { canViewRiskRating } = this.cardholderStore;
    return (
      canViewRiskRating && (
        <LoadingOverlay active={loading}>
          {this.renderEditRiskRatingModal()}
          {this.renderInfo()}
        </LoadingOverlay>
      )
    );
  }
}

export default observer(CardholderRiskRatingCard);
